const translations = {
    fetchDroneError: 'Failed to retrieve drones. Please try again later.'
};

export default translations;
